import {
  CREATE_PERMISSION_INIT,
  CREATE_PERMISSION_SUCCESS,
  CREATE_PERMISSION_FAILURE,
} from '@store/action-types/permissions';
import { enqueueSnackbar } from '@store/actions/toast';
import history from '@store/history';
import client from '@api-sdk/client';
import { set, toPath, isEmpty } from 'lodash';
import translateToastMessage from '@shared/utils/translateToastMessage';
import ROUTES from '@shared/consts/routes';

const createPermissionInit = () => ({ type: CREATE_PERMISSION_INIT });
const createPermissionSuccess = () => ({ type: CREATE_PERMISSION_SUCCESS });
const createPermissionFailure = error => {
  if (!error?.errors) {
    return { type: CREATE_PERMISSION_FAILURE, payload: { errors: error } };
  }

  const mappedErrors = error?.errors?.reduce?.((acc, item) => {
    if (item?.code === 'PERMISSION:NOT_UNIQUE_NAME') {
      set(acc, 'name', item.code?.split(':')?.pop() || item.message);
    }

    const path = toPath(item.context).filter(
      item => item !== 'children' && item !== 'data' && item !== 'pl' && item !== 'en',
    );
    set(acc, path, item.code?.split(':')?.pop() || item.message);

    return acc;
  }, {});

  return { type: CREATE_PERMISSION_FAILURE, payload: { errors: mappedErrors } };
};

const createPermission = ({ permissionData, saveAndBack = false }) => async dispatch => {
  dispatch(createPermissionInit());

  if (isEmpty(permissionData?.name)) {
    return dispatch(createPermissionFailure({ name: 'NAME_IS_EMPTY' }));
  }

  try {
    const createPermissionResponse = await client.createPermission({ data: permissionData });

    await dispatch(createPermissionSuccess(createPermissionResponse));

    if (saveAndBack) {
      history.push(ROUTES.PERMISSION_MANAGEMENT);
    } else {
      history.push(`/permission/${createPermissionResponse.response?.id}`);
    }

    dispatch(
      enqueueSnackbar({
        message: translateToastMessage('permission.create'),
        options: {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'success',
        },
      }),
    );
  } catch (error) {
    dispatch(
      enqueueSnackbar({
        message: translateToastMessage('permission.error.create'),
        options: {
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          variant: 'error',
        },
      }),
    );
    dispatch(createPermissionFailure(error));
  }
};

export default createPermission;
